import { validate } from "com";
import { ORDERS_ENDPOINTS } from "./endpoints";
import type { GetOrderDetailsResponse } from "./types";
import { apiGet } from "../shared";

export async function getOrderById(orderId: string): Promise<GetOrderDetailsResponse> {
  validate.uuid(orderId, "Order ID");
  return apiGet<GetOrderDetailsResponse>(ORDERS_ENDPOINTS.GET_BY_ID(orderId));
}

export default getOrderById;
